import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import type { WorkoutSessionDisplayData } from '../types/workoutLapData'

export const useWorkoutSessions = (workoutId: string) => {
  const { data, isFetching, isLoading, error, refetch } = useQuery<WorkoutSessionDisplayData>({
    queryKey: ['workout_sessions_laps', workoutId],
    enabled: workoutId !== undefined,
    queryFn: async () => {
      console.log('useWorkoutSessions', { workoutId })
      const { data, error: supabaseError } = await supabase
        .from('workout_sessions')
        .select(`
          *,
          workout_laps!workout_session_id (
            id,
            lap_number,
            start_time,
            total_timer_time,
            total_elapsed_time,
            total_distance,
            total_work,
            avg_power,
            avg_heart_rate,
            avg_speed,
            intensity
          )
        `)
        .eq('workout_id', workoutId)
      if (supabaseError) {
        throw new Error(supabaseError.message)
      }
      const displayData = {
        ...data?.[0],
        workout_laps: data?.[0]?.workout_laps || [],
      } as WorkoutSessionDisplayData
      return displayData
    },
  })
  return {
    data,
    isLoading,
    isFetching,
    refetch,
    error,
  }
}
